import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import TableSkeleton from "../../Reuseable/TableSkeleton";
import { Link, useNavigate } from "react-router-dom";
import { Tooltip, message } from "antd";
import DataParser from "../../../utlits/Dataparser";
import RelatedToServices from "../../../Services/RelatedToServices";
import secureLocalStorage from "react-secure-storage";
import { paginate } from "../../../utlits/Paginate.js";
import Pagination from "../../Reuseable/Pagination";
import StatusBadge from "../../Reuseable/StatusBadge";

message.config({ zIndex: 1000000001 });

const RelatedTo = () => {
  const [RelatedToList, setRelatedToList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [userPermissions, setuserPermissions] = useState([]);
  const [isLoading, setLoading] = useState(false);
  const [relatedToName, setRelatedToName] = useState("");
  const [relatedToEditName, setRelatedToEditName] = useState("");
  const [error, setError] = useState("");
  const [editValue, setEditValue] = useState(null);
  const [itemToDelete, setItemToDelete] = useState(null);

  const companyId = DataParser.CompanyId();
  const navigate = useNavigate();

  const getData = () => {
    setLoading(true);
    RelatedToServices.getRelatedToServices(companyId)
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
          return;
        }
        const data = res.data.relatedTo || [];
        setRelatedToList(data);
      })
      .catch((err) => {
        console.error("Error fetching lead types:", err);
        message.error("Failed to load lead types. Please try again!");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  useEffect(() => {
    getData();
    const upermission = DataParser.CompanyUserPermissions();
    setuserPermissions(upermission);
  }, []);

  useEffect(() => {
    if (pageSize > 15) setCurrentPage(1);
  }, [pageSize]);

  const handelPageChange = (e, page) => {
    e.preventDefault();
    setCurrentPage(page);
  };

  const clearCreateState = () => {
    setRelatedToName("");
    setError("");
  };

  const clearEditState = () => {
    setRelatedToEditName("");
    setEditValue(null);
    setError("");
  };

  const handelSubmit = (e) => {
    e.preventDefault();

    if (relatedToName.trim() === "") {
      setError("Lead type name is required!");
      return;
    }

    RelatedToServices.createRelatedTo({ name: relatedToName.trim(), company_id: companyId })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        } else if (res.Good === true) {
          message.success("Lead type created successfully!");
          const link = document.getElementById("closeCreateRelatedTo");
          if (link) link.click();
          setRelatedToName("");
          getData();
        } else {
          message.warning("Could not Create Lead Interest. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Create error:", err);
        message.error(
          err.response?.data?.message || "An error occurred while creating the lead type."
        );
      });
  };

  const handleOpenUpdate = (e, item) => {
    e.preventDefault();
    setRelatedToEditName(item.name);
    setEditValue(item);
    setError("");
  };

  const handelEditSubmit = (e) => {
    e.preventDefault();

    if (relatedToEditName.trim() === "") {
      setError("Lead type name is required!");
      return;
    }

    const id = editValue.id;
    RelatedToServices.editRelatedTo(id, { name: relatedToEditName.trim() })
      .then((res) => {
        if (res.data === "Un-Athunticated request") {
          message.error("Session expired! Please log in again.");
          secureLocalStorage.removeItem("adminInfo");
          secureLocalStorage.removeItem("admins");
          navigate("/");
        } else if (res.Good === true) {
          message.success("Lead type updated successfully!");
          const link = document.getElementById("closeEditRelatedTo");
          if (link) link.click();
          setRelatedToEditName("");
          getData();
        } else {
          message.warning("Could not update lead type. Please try again!");
        }
      })
      .catch((err) => {
        console.error("Update error:", err);
        message.error(
          err.response?.data?.message || "An error occurred while updating the lead type."
        );
      });
  };

  const handelDelete = (e, item) => {
    e.preventDefault();
    setItemToDelete(item);
    document.getElementById("openDeleteRelatedToModal").click();
  };

  const confirmDelete = async () => {
    if (!itemToDelete) return;
    const id = itemToDelete.id;
    setRelatedToList((prev) => prev.filter((el) => el.id !== id));
    document.getElementById("closeDeleteRelatedToModal").click();
    try {
      const res = await RelatedToServices.deleteRelatedToServices(id, companyId);
      if (res.data === "Un-Athunticated request") {
        secureLocalStorage.removeItem("adminInfo");
        secureLocalStorage.removeItem("admins");
        navigate("/");
      } else {
        message.success("Lead type deleted successfully!");
      }
      getData();
    } catch (err) {
      console.error("Delete error:", err);
      message.error("Failed to Delete Lead Interest. Please try again!");
      getData();
    }
    setItemToDelete(null);
  };

  const PaginatedData = paginate(RelatedToList, currentPage, pageSize);

  return (
    <>
      <Helmet>
        <title>Lead Interest - Planit</title>
      </Helmet>
      <div className="main-content">
        <div className="page-content Pagebody" style={{ backgroundColor: "#fff", minHeight: "100vh" }}>
          <div className="container-fluid">
            <div className="row">
              <div className="col-12 px-0">
                <div className="d-flex align-items-end justify-content-end" style={{ padding: "0 0 12px 0" }}>
                  <div className="d-flex flex-column align-items-end" style={{ gap: "6px" }}>
                    <ol className="breadcrumb mb-0">
                      <li className="breadcrumb-item">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/employee-attendance`}>Home</Link>
                      </li>
                      <li className="breadcrumb-item active">
                        <Link to={`/${DataParser.CompanyIdentifierRole()}/settings`}>Settings</Link>
                      </li>
                      <li className="breadcrumb-item active">Lead Interest</li>
                    </ol>
                    {userPermissions.indexOf("relatedto-create") !== -1 ? (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        style={{ borderRadius: "5px" }}
                        data-bs-toggle="modal"
                        data-bs-target="#createRelatedToModalDialog"
                      >
                        Create Lead Interest
                      </button>
                    ) : (
                      <button
                        type="button"
                        className="btn btn-primary waves-effect waves-light"
                        disabled
                        style={{ opacity: 0.6, cursor: "not-allowed", borderRadius: "5px" }}
                      >
                        Create Lead Interest
                      </button>
                    )}
                  </div>
                </div>
              </div>

              <div className="col-lg-12 px-0">
                <div className="card" style={{ backgroundColor: "#fff", boxShadow: "none", borderRadius: 0, border: "none" }}>
                  <div className="card-body p-0">
                    <div className="table-responsive listing-table-wrapper">
                      <table className="table mb-0 custom-table listing-table">
                        <thead>
                          <tr className="tableHeaderbg">
                            <th>Sr#</th>
                            <th>Name</th>
                            <th>Status</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {isLoading ? (
                            <TableSkeleton cols={4} rows={6} />
                          ) : PaginatedData && PaginatedData.length > 0 ? (
                            PaginatedData.map((item, index) => (
                              <tr key={item.id}>
                                <td>{index + 1}</td>
                                <td>{item.name}</td>
                                <td>
                                  {userPermissions.indexOf("relatedto-edit") !== -1 ? (
                                    <StatusBadge item={item} api={RelatedToServices.statusChange} />
                                  ) : (
                                    <>
                                      {item.status === "1" ? (
                                        <span className="badge bg-success text-white">Active</span>
                                      ) : (
                                        <span className="badge bg-danger text-white">Deactive</span>
                                      )}
                                    </>
                                  )}
                                </td>
                                <td className="tableset">
                                  {userPermissions.indexOf("relatedto-delete") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handelDelete(e, item)}
                                    >
                                      <Tooltip title="Delete Lead Interest">
                                        <i className="uil-trash iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-trash iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to delete"
                                    />
                                  )}
                                  {userPermissions.indexOf("relatedto-edit") !== -1 ? (
                                    <Link
                                      to="#"
                                      className="cursor-pointer iconscolor"
                                      onClick={(e) => handleOpenUpdate(e, item)}
                                      data-bs-toggle="modal"
                                      data-bs-target="#editRelatedToModalDialog"
                                    >
                                      <Tooltip title="Edit Lead Interest">
                                        <i className="uil-pen iconscolor" />
                                      </Tooltip>
                                    </Link>
                                  ) : (
                                    <span
                                      className="uil-pen iconscolor text-muted"
                                      style={{ cursor: "not-allowed", opacity: 0.5 }}
                                      title="You don't have permission to edit"
                                    />
                                  )}
                                </td>
                              </tr>
                            ))
                          ) : (
                            <tr>
                              <td colSpan="4" className="text-center">
                                Add your first lead type by clicking the 'Create Lead Interest' button.
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>

                      {RelatedToList.length > pageSize && (
                        <div className="d-flex justify-content-center mt-4">
                          <Pagination
                            itemCount={RelatedToList.length}
                            currentPage={currentPage}
                            pageSize={pageSize}
                            onPageChange={handelPageChange}
                          />
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Hidden trigger for delete modal */}
        <div id="openDeleteRelatedToModal" data-bs-toggle="modal" data-bs-target="#deleteRelatedToModal" style={{ display: "none" }} />

        {/* Delete Confirmation Modal */}
        <div id="deleteRelatedToModal" className="modal fade" tabIndex={-1} role="dialog" aria-hidden="true" data-bs-keyboard="false">
          <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
            <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
              <div className="modal-header border-0 pb-1">
                <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Delete Lead Interest</h5>
                <button type="button" className="btn-close" id="closeDeleteRelatedToModal" data-bs-dismiss="modal" aria-label="Close" onClick={() => setItemToDelete(null)} />
              </div>
              <div className="modal-body pt-2 pb-2">
                <p style={{ fontSize: "14px", color: "#1D1D1D", marginBottom: "6px" }}>Are you sure you want to delete this lead interest?</p>
                <p style={{ fontSize: "13px", color: "#ff4d4f", marginBottom: 0 }}>
                  <i className="uil uil-exclamation-triangle me-1" />
                  This action cannot be undone.
                </p>
              </div>
              <div className="modal-footer border-0 pt-1">
                <button type="button" className="btn btn-danger waves-effect waves-light" onClick={confirmDelete} style={{ borderRadius: "5px", fontSize: "13px" }}>
                  Delete
                </button>
              </div>
            </div>
          </div>
        </div>

        {/* Create Modal */}
        <div
          id="createRelatedToModalDialog"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={handelSubmit}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Create Lead Interest</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="closeCreateRelatedTo"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearCreateState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="RelatedToName"
                      placeholder=" "
                      value={relatedToName}
                      onChange={(e) => {
                        setRelatedToName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="RelatedToName">Lead Interest Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={handelSubmit}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    + Create Lead Interest
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>

        {/* Edit Modal */}
        <div
          id="editRelatedToModalDialog"
          className="modal fade"
          tabIndex={-1}
          role="dialog"
          aria-hidden="true"
          data-bs-keyboard="false"
        >
          <form onSubmit={handelEditSubmit}>
            <div className="modal-dialog modal-dialog-centered" style={{ display: "flex", alignItems: "center", minHeight: "calc(100vh - 3.5rem)", margin: "auto" }}>
              <div className="modal-content" style={{ borderRadius: "12px", border: "none", padding: "8px 4px" }}>
                <div className="modal-header border-0 pb-1">
                  <h5 className="modal-title fw-semibold" style={{ fontSize: "16px" }}>Edit Lead Interest</h5>
                  <button
                    type="button"
                    className="btn-close"
                    id="closeEditRelatedTo"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                    onClick={clearEditState}
                  />
                </div>
                <div className="modal-body pt-2 pb-2">
                  <div className="float-input-wrap">
                    <input
                      type="text"
                      className={error ? "is-invalid" : ""}
                      id="RelatedToNameEdit"
                      placeholder=" "
                      value={relatedToEditName}
                      onChange={(e) => {
                        setRelatedToEditName(e.target.value);
                        if (e.target.value.trim() !== "") setError("");
                      }}
                    />
                    <label htmlFor="RelatedToNameEdit">Lead Interest Name*</label>
                  </div>
                  {error && <small className="text-danger mt-1 d-block">{error}</small>}
                </div>
                <div className="modal-footer border-0 pt-1">
                  <button
                    type="button"
                    onClick={handelEditSubmit}
                    className="btn btn-primary waves-effect waves-light"
                    style={{ borderRadius: "5px", fontSize: "13px" }}
                  >
                    Save Changes
                  </button>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </>
  );
};

export default RelatedTo;
